export default __webpack_public_path__ + "static/media/SconeProductInfo5.006810cd.jpg";